import React from 'react';
import { FadeIn, Button } from './Shared';
import { Gift, ShoppingCart } from 'lucide-react';
export const BonusesTable = () => {
  const bonuses = [{
    num: '01',
    name: 'Mapa Rápido de Rutinas por Edad',
    value: '$8.000'
  }, {
    num: '02',
    name: 'Checklist Nocturno Anti-Caos',
    value: '$8.000'
  }, {
    num: '03',
    name: 'Guía Express de Señales de Cansancio Real',
    value: '$9.000'
  }, {
    num: '04',
    name: 'Planilla de Seguimiento 7 Días',
    value: '$8.000'
  }, {
    num: '05',
    name: 'Mini Guía de Noches Difíciles Sin Improvisar',
    value: '$9.000'
  }];
  return <section className="py-6 md:py-10 px-4 bg-navy-900 text-white" data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <FadeIn data-id="element-17">
          <div className="text-center mb-10" data-id="element-18">
            <h2 className="text-2xl md:text-3xl font-serif font-bold flex items-center justify-center text-yellow-400 drop-shadow-[0_0_10px_rgba(250,204,21,0.3)]" data-id="element-19">
              <Gift className="w-8 h-8 text-yellow-400 mr-4 shrink-0" data-id="element-20" />
              🎁 5 BONOS INCLUIDOS — SIEMPRE GRATIS
            </h2>
          </div>

          <div className="space-y-4 mb-8" data-id="element-21">
            {bonuses.map((bono, index) => <div key={index} className="bg-navy-800/80 rounded-2xl border border-navy-600 p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:border-yellow-400/50 hover:bg-navy-800 transition-all shadow-lg hover:shadow-[0_0_20px_rgba(250,204,21,0.15)] group relative overflow-hidden" data-id="element-22">
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-yellow-400 to-yellow-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-23" />
                <div className="flex items-center gap-4" data-id="element-24">
                  <span className="text-2xl font-bold text-yellow-500/40 font-serif group-hover:text-yellow-400/80 transition-colors" data-id="element-25">
                    {bono.num}
                  </span>
                  <h3 className="text-lg font-medium text-white leading-tight group-hover:text-yellow-100 transition-colors" data-id="element-26">
                    {bono.name}
                  </h3>
                </div>
                <div className="flex items-center justify-between sm:justify-end gap-4 sm:shrink-0" data-id="element-27">
                  <div className="flex items-center gap-3" data-id="element-28">
                    <span className="text-gray-300 line-through text-sm" data-id="element-29">
                      {bono.value}
                    </span>
                    <span className="text-green-400 font-black bg-green-400/10 px-4 py-1.5 rounded-full text-sm border border-green-400/30 shadow-[0_0_10px_rgba(74,222,128,0.2)]" data-id="element-30">
                      GRATIS
                    </span>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="bg-gradient-to-br from-navy-800 to-navy-900 rounded-2xl border-2 border-yellow-400/40 p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 shadow-[0_0_30px_rgba(250,204,21,0.15)] relative overflow-hidden" data-id="element-31">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-yellow-400/10 rounded-full blur-2xl" data-id="element-32" />
            <div className="text-center md:text-left relative z-10" data-id="element-33">
              <p className="text-yellow-400/80 uppercase tracking-widest text-sm font-bold mb-1" data-id="element-34">
                VALOR TOTAL DE LOS BONOS
              </p>
              <h4 className="text-2xl md:text-3xl font-serif font-bold text-white" data-id="element-35">
                Todo esto es tuyo sin costo extra
              </h4>
            </div>
            <div className="text-center md:text-right relative z-10" data-id="element-36">
              <span className="text-gray-300 line-through text-xl block mb-1" data-id="element-37">
                $42.000
              </span>
              <span className="text-green-400 font-black text-4xl md:text-5xl drop-shadow-[0_0_15px_rgba(74,222,128,0.4)]" data-id="element-38">
                GRATIS
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};